import { render, staticRenderFns } from "./ContactAddTag.component.vue?vue&type=template&id=0177224a&scoped=true&"
import script from "./ContactAddTag.component.vue?vue&type=script&lang=js&"
export * from "./ContactAddTag.component.vue?vue&type=script&lang=js&"
import style0 from "./ContactAddTag.component.vue?vue&type=style&index=0&id=0177224a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177224a",
  null
  
)

export default component.exports